import { InternalAxiosRequestConfig } from 'axios';
import cookie from 'js-cookie';
import { makeApiClient } from '~/api/client';

const BASE_URL_SUFFIX = 'v1';

const baseUrl = `${process.env.NEXT_PUBLIC_LOCATIONS_API}/${BASE_URL_SUFFIX}`;
const guestAccessToken = process.env.NEXT_PUBLIC_LOCATIONS_API_KEY;

const interceptorReq = (req: InternalAxiosRequestConfig) => {
  const accessToken = cookie.get('accessToken');
  // Append the access token if it exists and there is no manual X-AUTH-TOKEN header defined
  if (req.headers['X-AUTH-TOKEN']) return req;

  req.headers['X-AUTH-TOKEN'] = accessToken ? accessToken : guestAccessToken;
  return req;
};

export default makeApiClient(baseUrl, {}, interceptorReq);
